/**
 * Reference Code Mapping for Scaffold
 * Maps field names to Evaluate codes (resourceCode in Item Library API)
 */

export interface ScaffoldReferenceCodeMapping {
  code?: string;
}

/**
 * Scaffold Reference Codes
 * Maps field names from scaffold tables to Evaluate codes
 */
export const SCAFFOLD_REFERENCES: Record<
  string,
  ScaffoldReferenceCodeMapping
> = {
  // Base measurements (no codes - just quantities)
  scaffoldPlatform: {},
  loadingBay4x2m: {},
  stairAccess3x3m: {},

  // Section 1 - Scaffold Platform
  scaffoldLevelCompact: { code: "GWALP005" },
  scaffoldGeotextileLayer: { code: "ALP031A" },
  scaffoldCrush6F2: { code: "GWALP004" }, // xxxmm crush 6F2 - may be dynamic
  scaffoldType1: { code: "GWALP006" }, // xxmm Type1 - may be dynamic

  // Section 2 - Loading Bays
  loadingLevelCompact: { code: "GWALP005" },
  loadingGeotextileLayer: { code: "ALP031A" },
  loadingCrush6F2: { code: "GWALP004" }, // xxxmm crush 6F2 - may be dynamic
  loadingType1: { code: "GWALP006" }, // xxmm Type1 - may be dynamic

  // Section 3 - Stair Access
  stairLevelCompact: { code: "GWALP005" },
  stairGeotextileLayer: { code: "ALP031A" },
  stairCrush6F2: { code: "GWALP004" }, // xxxmm crush 6F2 - may be dynamic
  stairType1: { code: "GWALP006" }, // xxmm Type1 - may be dynamic
};

/**
 * Get reference code for a specific field
 */
export const getScaffoldReferenceCode = (
  referenceKey: string,
): string | undefined => {
  return SCAFFOLD_REFERENCES[referenceKey]?.code;
};

/**
 * Get full reference information for a specific field
 */
export const getScaffoldReference = (
  referenceKey: string,
): ScaffoldReferenceCodeMapping | undefined => {
  return SCAFFOLD_REFERENCES[referenceKey];
};
